import { Controller, useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Card,
  Radio,
  RadioGroup,
} from '@material-ui/core'

import constants from 'constants/index'

import useStyles from './styles'

const RadioType = ({ disabled = false }) => {
  const classes = useStyles()

  const { control, watch, errors } = useFormContext()

  const watchedKind = watch('kind')

  return (
    <Grid item xs={12}>
      <FormControl size="small" variant="outlined">
        <Controller
          control={control}
          name="kind"
          as={
            <RadioGroup row className={classes.radioGroup}>
              {constants.organizations.REAL_ORGANIZATION_KINDS.map((kind) => (
                <Card
                  className={clsx({
                    [classes.selected]: watchedKind === kind.id,
                    [classes.cardMaterial]: watchedKind !== kind.id,
                    [classes.error]: !!errors?.kind,
                  })}
                  key={kind.id}
                >
                  <FormControlLabel
                    label={kind.name}
                    value={kind.id}
                    control={<Radio />}
                    disabled={disabled}
                  />
                </Card>
              ))}
            </RadioGroup>
          }
        />
      </FormControl>
    </Grid>
  )
}

export default RadioType
